export default [
    {
        path: '/construction-standards',
        name: 'construction-standards',
        props: {parentRouteName: 'construction-standards'},
        component: () => import(/* webpackChunkName: "construction-standards" */ '@/components/AppModuleNavigator.vue'),
        meta: {
            title: 'CONSTRUCTION STANDARDS',
            icon: 'mdi-table-search'
        },
        children: [
            {
                path: 'design-guidelines',
                name: 'construction-standards-design-guidelines',
                component: () => import(/* webpackChunkName: "construction-standards" */ '../pages/DesignGuidelines.vue'),
                meta: {
                    title: 'DESIGN GUIDELINES',
                    icon: 'mdi-table-search',
                    gtm: 'construction-standards-design-guidelines'
                }
            }, {
                path: 'front-end-documents',
                name: 'construction-standards-front-end-documents',
                component: () => import(/* webpackChunkName: "construction-standards" */ '../pages/FrontEndDocuments'),
                meta: {
                    title: 'FRONT END DOCUMENTS',
                    icon: 'mdi-table-search',
                    gtm: 'construction-standards-front-end-documents'
                }
            }, {
                path: 'technical-standards',
                name: 'construction-standards-technical-standards',
                component: () => import(/* webpackChunkName: "construction-standards" */ '../pages/TechnicalStandards'),
                meta: {
                    title: 'TECHNICAL STANDARDS',
                    icon: 'mdi-table-search',
                    gtm: 'construction-standards-technical-standards'
                }
            }, {
                path: 'standard-details',
                name: 'construction-standards-standard-details',
                component: () => import(/* webpackChunkName: "construction-standards" */ '../pages/StandardDetails'),
                meta: {
                    title: 'STANDARD DETAILS',
                    icon: 'mdi-table-search',
                    gtm: 'construction-standards-standard-details'
                }
            },
            {
                path: '/construction-standards',
                name: 'construction-standards-default',
                redirect: '/construction-standards/design-guidelines',
                meta: {
                    title: 'redirect'
                }
            }
        ]
    }
]
